import DDMOffers from '../../auto/stores/DDMOffers';
import VersionComparison from '../../auto/stores/VersionComparison';
import vehicleVersionDetails from '../../auto/stores/vehicleVersionDetails';

(function () {
  // Adicione chaves:valor com os stores que serão atribuídos ao escopo
  // global
  const store = {
    DDMOffers,
    VersionComparison,
    vehicleVersionDetails,
  };
  window.store = Object.assign(window.store || {}, {});
  // eslint-disable-next-line no-return-assign
  Object.keys(store).forEach(c => (window.store[c] = store[c]()));
})();
